import React from "react";
import ServiceNetworkHeader from "./ServiceNetworkHeader/ServiceNetworkHeader";
import You_might_also_like from "../common_components/You_might_also_like/You_might_also_like";
import Contactus from "../CommonPage/Contact/Contactus";
import TestimonialSection from "../Career_Solutions/TestimonialSection/TestimonialSection";
import FaqSection from "../Career_Solutions/FaqSection/FaqSection";
import ScamAlertBanner from "../common_components/scamAlertBanner/ScamAlertBanner";

function ServiceNetwork() {

  const recommendationsData = [
    {
      imageSrc: "/assets/Images/career_solutions/ServiceSection/xpress-resume.svg",
      title: "Featured Profile",
      link: "/career-booster",
      description: "Rank higher in recruiter searches and dramatically increase your profile views.",
      price: "₹699"
    },
    {
      imageSrc: "/assets/Images/career_solutions/ServiceSection/resume-builder.svg",
      title: "Resume Builder",
      link: "/career-booster", // Update if you have a separate route like /resume-builder
      description: "Create an ATS-friendly, professional resume that gets you short-listed by top employers.",
      price: "₹4599"
    },
    {
      imageSrc: "/assets/Images/career_solutions/ServiceSection/linkedin-makeover.svg",
      title: "LinkedIn Makeover",
      link: "/career-booster", // Update if you have a separate route like /linkedin-makeover
      description: "Optimize your headline, summary, and experience to attract headhunters organically.",
      price: "₹4599"
    }
  ];

  // Swiper breakpoints configuration
  const customBreakpoints = {
    576: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3, 
    }
  };

  return (
    <>
      <ServiceNetworkHeader />

      <You_might_also_like
        data={recommendationsData} 
        breakpoints={customBreakpoints} 
      />

      <Contactus />

      <TestimonialSection />

      <FaqSection />

      <ScamAlertBanner />
    </>
  );
}

export default ServiceNetwork;